import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import showAlert from "utils/showAlert";

export default function SetUpApiAccessModal(props) {
  console.log(props);

  const org = props.org;

  const [isModalVisible, setIsModalVisible] = useState(props.show || false);

  const hideModal = () => setIsModalVisible(false);

  const goToApiAccess = () => {
    hideModal();
    window.location.href = "/datapulse/api-access";
  }

  return (
    <>
      <Modal show={isModalVisible} onHide={hideModal} className="set-up-api-access-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>Next step: Set up Data Connections</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <p className="mb-2"><b>Great job creating your first account!</b></p>
            <p>The next step is to set up your Data Connections so you can pull in your data for {org.name}.</p>
            <p>Head over to the Data Connections page to authenticate with the platforms you use.</p>
          </div>

          <div className="set-up-api-access-buttons">
            <button type="button" className="button b-size-normal skip-button" onClick={hideModal}>
              Cancel
            </button>
            <button type="button" className="button b-type-primary b-size-normal b-color-green api-access-button" onClick={goToApiAccess}>
              <img className="filter-white" src={`/datapulse${require("images/lite/icons/overview.svg")}`} alt="Data Connections Icon" />
              Set up Data Connections
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
